import './flowbite.css';

// core components
import './components/accordion';
import './components/collapse';
import './components/carousel';
import './components/dropdown';
import './components/tabs';
import './components/modal';
import './components/tooltip';
